import { styled } from 'styled-components';
import { colors } from '../../abstracts';
import { Card as CoreCard } from '../Card';
import { Text as CoreText } from '../Text';
import { Icon } from '../Icon';
import { Link as CoreLink } from '../Link';
import { dontForwardProps } from '../../util';
export const Card = styled(CoreCard).withConfig({
  componentId: "aui__sc-1olnv8w-0"
})(["&&&{text-align:unset;}"]);
export const Text = styled(CoreText).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-1"
})(["&&&{", ";}"], ({
  disabled
}) => disabled && `color: ${colors.disabledText}`);
export const StoreCardIcon = styled(Icon.SSR).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-2"
})(["flex-shrink:0;"]);
export const Link = styled(CoreLink).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-3"
})(["&&&{font-size:0.875rem;color:", ";text-decoration:none;pointer-events:", ";cursor:", ";:hover,:visited,:active{color:", ";}}"], ({
  disabled
}) => disabled ? colors.disabledText : colors.neutralDeepest, ({
  disabled
}) => disabled ? 'none' : 'auto', ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', colors.neutralDeepest);
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-4"
})(["display:flex;justify-content:space-between;text-align:unset;color:", ";"], colors.neutralDeepest);
export const StoreCardContent = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-5"
})([""]);
export const StoreInformationContainer = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-6"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;"]);
export const PrimaryTextWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-7"
})(["display:flex;align-items:unset;", ";", ";", ";"], ({
  map
}) => map && 'margin-top: 0.5rem', ({
  icon
}) => icon && 'margin-top: 0.5rem', ({
  disabled
}) => disabled && `color: ${colors.disabledText}`);
export const CircleBadge = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-8"
})(["&&&{width:1.25rem;height:1.25rem;background-color:", ";border-radius:62.5rem;display:flex;justify-content:center;text-align:center;align-items:center;flex-shrink:0;margin-top:0.188rem;", ";}"], ({
  badgeColor,
  theme
}) => theme[badgeColor], ({
  disabled
}) => disabled && `background-color: ${colors.disabledText}`);
export const CircleBadgeNumber = styled(CoreText).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-9"
})(["margin-bottom:", ";margin-left:-0.5px;margin-top:0.5px;"], ({
  storeNameSize
}) => storeNameSize === 3 ? '-3px' : '-2px');
export const StoreName = styled(CoreText).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-10"
})(["&&&{", ";line-height:", ";}"], ({
  showBadge
}) => showBadge && `margin-left: 0.5rem`, ({
  storeNameSize
}) => storeNameSize === 3 ? '1.4' : '1.2');
export const Ranking = styled(CoreText).withConfig({
  componentId: "aui__sc-1olnv8w-11"
})(["&&&{margin-left:0.5rem;}"]);
export const MilesAway = styled(CoreText).withConfig({
  componentId: "aui__sc-1olnv8w-12"
})(["&&&{margin-left:0.5rem;}"]);
export const ChevronIconContainer = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-13"
})(["display:flex;align-items:center;margin-left:1.188rem;"]);
export const StarSVG = styled.svg.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-14"
})(["&&&{path{fill:", ";stroke:", ";}}"], ({
  disabled
}) => disabled ? colors.disabledText : colors.warningDeep, ({
  disabled
}) => disabled ? null : '#8a5300');
export const TextWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1olnv8w-15"
})(["margin-top:0.5rem;", ";"], ({
  disabled
}) => disabled && `color: ${colors.disabledText}`);
export const InformationTextContainer = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-16"
})(["display:flex;align-items:center;text-align:left;margin-top:0.5rem;gap:0.5rem;"]);
export const OpenHoursContainer = styled.div.withConfig({
  componentId: "aui__sc-1olnv8w-17"
})(["display:flex;justify-content:space-between;gap:0.5rem;"]);